import { delay } from 'msw'
import type { PaginatedResponse, PaginationParams } from '@/types/api.types.ts'

export const randomBool = (p = 0.7) => Math.random() < p
export const randomDelay = (min = 200, max = 800) =>
  delay(Math.floor(Math.random() * (max - min) + min))
export const createSeq = (start: number = 1) => {
  let current = start - 1

  return () => {
    current += 1

    return current
  }
}

export const startMocksServer = async () => {
  const { worker } = await import('@/services/mocks/worker.ts')

  await worker.start()
}

export const getAvatarUrl = (
  name: string,
  background: string,
  size: number,
) => {
  const url = new URL('https://ui-avatars.com/api/')
  url.searchParams.set('name', name)
  url.searchParams.set('background', background)
  url.searchParams.set('size', size.toString())

  return url.toString()
}

export const paginateResponse = <T>(
  items: Array<T>,
  { offset, limit }: PaginationParams,
): PaginatedResponse<T> => {
  return {
    total: items.length,
    offset,
    limit,
    items: items.slice(offset, offset + limit),
  }
}
